import classNames from 'classnames'
import Tooltip from 'rc-tooltip'
import { type ReactElement, useCallback } from 'react'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { NavLink, useLocation } from 'react-router-dom'

import type { INavBarLink } from '../types'

import { checkUrlMatch } from '../utils'

import './styles.scss'

interface Props {
  authorizations: string[]
  hoveredItems: string[]
  isCollapsed: boolean
  level: number
  onHover: (value: string, level: number) => void
  submenu?: INavBarLink[]
  title?: string
}

const SubMenuPortal = ({
  authorizations,
  hoveredItems,
  isCollapsed,
  level,
  onHover,
  submenu,
  title,
}: Props): ReactElement | null => {
  const location = useLocation()

  const isSubLinkActive = useCallback(
    (url: string, withSubmenu: boolean) =>
      withSubmenu ? checkUrlMatch(location.pathname, url) : location.pathname.includes(url),
    [location.pathname]
  )

  const handleMouseEnter = (name: string) => () => onHover(name, level)

  const handleClickMenuItem = () => onHover('', level)

  return (
    <div className="submenu-portal">
      {isCollapsed && title ? (
        <div className={classNames('submenu-portal__title', { 'title-only': !submenu })}>{title}</div>
      ) : null}
      {submenu ? (
        <div className={classNames('submenu-portal__content', { 'with-title': isCollapsed && title })}>
          {submenu.map(({ authorization, name, submenu, url }, index) =>
            !authorization || authorizations.includes(authorization) ? (
              <Tooltip
                align={{
                  offset: [14, 0],
                }}
                key={url + index}
                overlay={
                  submenu ? (
                    <SubMenuPortal
                      authorizations={authorizations}
                      hoveredItems={hoveredItems}
                      isCollapsed={isCollapsed}
                      level={level + 1}
                      onHover={onHover}
                      submenu={submenu}
                      title={name}
                    />
                  ) : null
                }
                placement="right"
              >
                <NavLink
                  className={classNames('nav-link-submenu-item', {
                    hovered: hoveredItems[level] === name,
                    'submenu-active': isSubLinkActive(url, !!submenu),
                  })}
                  end
                  onClick={handleClickMenuItem}
                  onMouseEnter={handleMouseEnter(name)}
                  to={url}
                >
                  <div className="nav-link-title">
                    {name}
                    {submenu ? <MdKeyboardArrowRight className="nav-link-title__arrow" color="#fff" size={14} /> : null}
                  </div>
                </NavLink>
              </Tooltip>
            ) : null
          )}
        </div>
      ) : null}
    </div>
  )
}

export default SubMenuPortal
